const CANDIDATES = "candidates";
const ELECTED_OFFICIALS = "elected-officials";
const REGISTER_TO_VOTE = "register-to-vote";
const VOTER_INFORMATION = "voter-information";

export default {
  CANDIDATES,
  ELECTED_OFFICIALS,
  REGISTER_TO_VOTE,
  VOTER_INFORMATION
};
